import { z } from 'zod';

export const nameSchema = z.coerce.string().trim().min(1);
